import { SsrVersionedService as SsrBaseVersionedService } from "./VersionedOptions/^0.0.0.0/SsrVersionedService";
import { Ssr_4_0_0_0 } from "./VersionedOptions/^4.0.0.0/SsrVersionedService";
export class SsrConfigService extends SsrBaseVersionedService {
    constructor() {
        super();
        this._services = {
            Ssr_4_0_0_0: new Ssr_4_0_0_0(),
        };
    }
    GetServiceName() {
        return SsrConfigService.ServiceName;
    }
    VersionedConfigurationOptions() {
        return {
            ['^4.0.0.0']: this._services.Ssr_4_0_0_0,
        };
    }
}
SsrConfigService.ServiceName = "SsrConfigService";
//# sourceMappingURL=SsrConfigService.js.map